import React from 'react';
import { TenantSelector } from './TenantSelector';
import { LanguagePicker } from './LanguagePicker';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';
import { NotificationDropdown } from './NotificationDropdown';
import { useSidebar } from '../hooks/useSidebar';
import { useTranslation } from 'react-i18next';

interface HeaderProps {
  onMenuToggle?: () => void;
}

export function Header({ onMenuToggle }: HeaderProps) {
  const { t } = useTranslation();
  const { isOpen, isMobile } = useSidebar();

  return (
    <header className="app-header" role="banner">
      <div className="d-flex align-items-center">
        <button
          className="sidebar-toggle-btn"
          onClick={onMenuToggle}
          aria-label={t('header.toggle_sidebar', 'Toggle sidebar')}
          aria-expanded={isOpen}
          aria-controls="sidebar"
          type="button"
        >
          <i className="bi bi-list" aria-hidden="true"></i>
        </button>
        <ul className="navbar-nav">
          <TenantSelector />
        </ul>
      </div>

      <div className="d-flex align-items-center gap-2">
        <ThemeToggle />
        <LanguagePicker />
        <NotificationDropdown />
        <UserMenu />
      </div>
    </header>
  );
}
